import Vue from 'vue';
import axios from 'axios';

export default {
  namespaced: true,
  state: {},
  mutations: {
    setRegistry(state, { path, response }) {
      Vue.set(state, path, response );
    },
  },
  actions: {
    async loadRegistries({ commit }, path) {
      const response = await axios.get(`/rest/v4/${path}`);
      commit('setRegistry', { path, response });
    }
  },
  getters: {
    getRegistry: state => path => state[path]
  },
}
